module.exports = __webpack_public_path__ + "img/email-line.32cf14c5.svg";